module.exports = __webpack_public_path__ + "media/images/frontend/btn_blue_bg-0c4070fbb0aa4c153de1d135b695052c.svg";